/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionSeriesGame
 */
export interface CompetitionSeriesGame {
    /**
     * 
     * @type {number}
     * @memberof CompetitionSeriesGame
     */
    gameNumber: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionSeriesGame
     */
    participant1Score: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionSeriesGame
     */
    participant2Score: number;
    /**
     * 
     * @type {string}
     * @memberof CompetitionSeriesGame
     */
    winnerId?: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionSeriesGame
     */
    reportedAt: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionSeriesGame
     */
    confirmedAt?: number;
}

/**
 * Check if a given object implements the CompetitionSeriesGame interface.
 */
export function instanceOfCompetitionSeriesGame(value: object): value is CompetitionSeriesGame {
    if (!('gameNumber' in value) || value['gameNumber'] === undefined) return false;
    if (!('participant1Score' in value) || value['participant1Score'] === undefined) return false;
    if (!('participant2Score' in value) || value['participant2Score'] === undefined) return false;
    if (!('reportedAt' in value) || value['reportedAt'] === undefined) return false;
    return true;
}

export function CompetitionSeriesGameFromJSON(json: any): CompetitionSeriesGame {
    return CompetitionSeriesGameFromJSONTyped(json, false);
}

export function CompetitionSeriesGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionSeriesGame {
    if (json == null) {
        return json;
    }
    return {
        
        'gameNumber': json['gameNumber'],
        'participant1Score': json['participant1Score'],
        'participant2Score': json['participant2Score'],
        'winnerId': json['winnerId'] == null ? undefined : json['winnerId'],
        'reportedAt': json['reportedAt'],
        'confirmedAt': json['confirmedAt'] == null ? undefined : json['confirmedAt'],
    };
}

export function CompetitionSeriesGameToJSON(json: any): CompetitionSeriesGame {
    return CompetitionSeriesGameToJSONTyped(json, false);
}

export function CompetitionSeriesGameToJSONTyped(value?: CompetitionSeriesGame | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameNumber': value['gameNumber'],
        'participant1Score': value['participant1Score'],
        'participant2Score': value['participant2Score'],
        'winnerId': value['winnerId'],
        'reportedAt': value['reportedAt'],
        'confirmedAt': value['confirmedAt'],
    };
}

